import { TrainingDisplayCard } from "@academy-context/primary/shared/external-provider-batch-display/training-display-card.content";
import { ComplementaryInfoCard } from "@academy-context/primary/shared/external-provider-batch-display/complementary-info-card.content";
import { StudentDisplayCard } from "@academy-context/primary/shared/external-provider-batch-display/student-display-card.content";
import { ProviderDisplayCard } from "@academy-context/primary/shared/external-provider-batch-display/provider-display-card.content";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface Props {
  data: ExternalProviderDashboardVM;
}

export const RequestDataReadOnly = ({ data }: Props) => {
  return (
    <div className="space-y-6">
      {/* Student Info */}
      <StudentDisplayCard student={data.student} variant="provider" />

      {/* Provider Info */}
      <ProviderDisplayCard provider={data.provider} variant="provider" />

      {/* Training Details */}
      <TrainingDisplayCard training={data.training} variant="provider" />

      {/* Additional Info */}
      <ComplementaryInfoCard
        data={{
          trainingLocation: data.training.trainingLocation,
          equipmentDescription: data.training.equipmentDescription,
          speakers: data.training.speakers,
        }}
        variant="provider"
      />
    </div>
  );
};
